import { Trans, useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { FiltersButton } from '@/design_system/Filters/FiltersButton/FiltersButton';
import { FiltersMenu } from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import InputSearch from '@/design_system/InputSearch';
import Stack from '@/design_system/Stack';
import IconCross from '@/icons/Cross.svg';

import { useFilters } from '../FiltersState';

import { FiltersGroup } from './FiltersGroup';
import { FiltersTrait } from './FiltersTrait';
import { FiltersType } from './FiltersType';

export const DesktopFilters = () => {
  const { t } = useLingui();

  const { search, activeFiltersCount, clearFilters } = useFilters();

  return (
    <Stack gap="0.75rem">
      <Stack row gap="1rem" alignItems="center">
        <FiltersMenu button={<FiltersButton />}>
          <FiltersTrait />
          <FiltersType />
          <FiltersGroup />
        </FiltersMenu>
        <InputSearch
          ariaLabel={t({
            id: 'settings.organization.entities.entities.search.label',
            message: 'Search entities',
          })}
          placeholder={t({
            id: 'settings.organization.entities.entities.search.placeholder',
            message: 'Search entities...',
          })}
          value={search.search}
          onChange={search.debouncedSetSearch}
          style={{ flex: 1 }}
        />
      </Stack>

      {activeFiltersCount > 0 && (
        <Stack row gap="1rem" justifyContent="space-between" alignItems="center" flexWrap="nowrap">
          <Stack row gap="0.5rem">
            <FiltersTrait tag />
            <FiltersType tag />
            <FiltersGroup tag />
          </Stack>

          <Button
            variant="link-subtle"
            onPress={clearFilters}
            style={{ textWrap: 'nowrap' }}
            size="small"
          >
            <IconCross />
            <Trans id="settings.organization.entities.entities.filters.clear_all">
              Clear filters
            </Trans>
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
